module.exports = "/packs/007-6ed29582c9b523c4fb161af7fe7c5876.jpg";